import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Clock, Phone, Star, ShieldCheck, Zap, Award, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_mein-schuster/artifacts/rz6vntl1_Schlu%CC%88sseldienst.jpeg";
const SHOE_IMG = "https://images.pexels.com/photos/28387105/pexels-photo-28387105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";
const KEY_IMG = "https://images.pexels.com/photos/34286675/pexels-photo-34286675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";
const CAR_KEY_IMG = "https://images.pexels.com/photos/30158089/pexels-photo-30158089.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900";

// Aktuellste Google-Bewertungen — Stand Okt. 2026 (Google-Profil: 4,8 / 5 · 109 Rezensionen)
// Quelle: öffentliche Google-Rezensionen des Betriebs. Chronologisch neueste zuerst.
const testimonials = [
    { name: "Google-Kunde", date: "Okt. 2026", text: "Top Service!", rating: 5 },
    { name: "N. Seidl", date: "Sep. 2026", text: "Top Service.", rating: 5 },
    { name: "Marion", date: "Juli 2026", text: "Gigantischer Service!!! Ich hab mir ein gebrauchtes Auto gekauft, jedoch war der Zweitschlüssel nicht mehr vorhanden. Ich wandte mich an den Schlüsseldienst im DEZ.", rating: 5 },
    { name: "Willi", date: "Juni 2026", text: "Absolut empfehlenswert! Ich brauchte kurzfristig einen neuen Schlüssel und dieser wurde innerhalb weniger Minuten angefertigt. Der Herr war sehr freundlich, hilfsbereit und hat sich Zeit genommen, alles zu erklären.", rating: 5 },
    { name: "Google-Kunde", date: "Google", text: "Und sehr schnell fertig. Sehr nett und sympathisch.", rating: 5 },
    { name: "Google-Kunde", date: "Google", text: "Sehr netter Chef – bin sehr zufrieden mit der Arbeit.", rating: 5 },
    { name: "Google-Kunde", date: "Feb. 2026", text: "Innerhalb von nur drei Werktagen waren meine Stiefel nicht nur fachmännisch repariert, sondern perfekt poliert. Beeindruckend die hochwertige Vibram Gumlite-Sohle. Herr Andrea hat die Arbeit mit sichtbarer Sorgfalt und Fachkenntnis erledigt und mich durchgehend freundlich beraten.", rating: 5 },
    { name: "Google-Kunde", date: "Nov. 2025", text: "Bester Schlüsseldienst in Regensburg 😊 Sehr nette und kompetente Beratung, schnell und unkompliziert.", rating: 5 },
    { name: "Google-Kunde", date: "Nov. 2024", text: "Sehr freundlich empfangen von einem älteren Herrn mit viel Humor. Der Schlüssel war in Sekundenschnelle fertig – für 9,90 €. Top Service.", rating: 5 },
    { name: "Google-Kunde", date: "Okt. 2024", text: "Ich wurde bisher immer sehr freundlich bedient – egal ob für neue Absätze an meinen Wanderschuhen oder einen Ersatzschlüssel. Die Preise fand ich dabei immer völlig angemessen.", rating: 5 },
    { name: "Google-Kunde", date: "Juni 2024", text: "Mir ist am Wochenende der Fahrradschlüssel abgebrochen – mit den beiden Bruchstücken bin ich am Tag danach dorthin. Innerhalb weniger Minuten konnte er daraus einen Ersatzschlüssel anfertigen. Passte auf Anhieb perfekt.", rating: 5 },
    { name: "Google-Kunde", date: "Feb. 2024", text: "Sehr netter und schneller Service! Preis-Leistung passt ebenfalls 👍", rating: 5 },
    { name: "Lukas Trissl", date: "Google", text: "Schnelle und sehr kompetente Gürtelkürzung.", rating: 5 },
    { name: "Stefan Elbel", date: "Google", text: "War schon diverse Male da. Sogar ein alter Honda-Motorradschlüssel wurde auf zwei Originalrohlinge übertragen – beide Kopien sperren einwandfrei. Nur zu empfehlen!", rating: 5 },
    { name: "Rudolf Gritschmeier", date: "Google", text: "Absolut freundlich. Kann Autoschlüssel nachmachen, was z. B. der Baumarkt nicht kann. Fairer Preis – deswegen gab's auch Trinkgeld. Komme wieder.", rating: 5 },
    { name: "Andrea", date: "Google", text: "Bin super zufrieden! Meine Schuhe wurden innerhalb kürzester Zeit repariert und sehen wieder top aus.", rating: 5 },
    { name: "Selim Yilmaz", date: "Google", text: "Lustiger, netter Verkäufer – auf jeden Fall empfehlenswert.", rating: 5 },
    { name: "Google-Kunde", date: "Google", text: "Freundliches Team und saubere Handwerksarbeit. Immer wieder gerne.", rating: 5 },
];

export default function Home() {
    return (
        <div data-testid="page-home">
            {/* ---------- HERO ---------- */}
            <section className="relative overflow-hidden border-b border-line" data-testid="hero-section">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-10 md:pt-16 pb-20 md:pb-24">
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                        {/* Copy column */}
                        <div className="lg:col-span-7 reveal">
                            {/* Big logo */}
                            <div className="mb-10 -ml-3 md:-ml-5">
                                <Logo size="2xl" />
                            </div>

                            <div className="flex items-center gap-4 mb-8 hidden">
                                <span className="h-px w-10 bg-brand" />
                            </div>

                            <h1 className="font-display text-5xl sm:text-6xl lg:text-[80px] tracking-tighter leading-[0.95] font-medium text-ink" data-testid="hero-title">
                                Schuh- &amp;<br/>
                                <span className="text-brand italic">Schlüsseldienst</span>.
                            </h1>

                            <p className="mt-5 font-body text-sm tracking-[0.28em] uppercase font-semibold text-brand" data-testid="hero-since">
                                Seit 2002
                            </p>

                            <p className="mt-7 font-body text-lg md:text-xl font-light text-inkSoft max-w-2xl leading-snug" data-testid="hero-subtitle">
                                Schlüsseldienst · Schuster · Programmierung von Autoschlüsseln · uvm.
                            </p>

                            <div className="mt-6 flex items-center gap-3 text-sm text-inkSoft font-body" data-testid="hero-location">
                                <MapPin size={16} className="text-brand" />
                                <span>Regensburg · Donau-Einkaufszentrum (DEZ)</span>
                            </div>

                            <div className="mt-10 flex flex-wrap items-center gap-4">
                                <a
                                    href="tel:+499414610027"
                                    data-testid="hero-cta-call"
                                    className="group inline-flex items-center gap-3 bg-brand text-paper px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-brandDark transition-colors duration-300"
                                >
                                    <Phone size={14} />
                                    Jetzt anrufen
                                </a>
                                <a
                                    href="https://wa.me/4917620366268"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="hero-cta-whatsapp"
                                    className="group inline-flex items-center gap-3 bg-[#25D366] text-white px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#1DA851] transition-colors duration-300"
                                >
                                    <MessageCircle size={14} />
                                    WhatsApp
                                </a>
                                <Link
                                    to="/leistungen"
                                    data-testid="hero-cta-services"
                                    className="inline-flex items-center gap-2 px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold text-ink border border-ink/30 hover:border-ink hover:bg-ink hover:text-paper transition-colors"
                                >
                                    Unsere Leistungen
                                    <ArrowUpRight size={14} />
                                </Link>
                                <Link
                                    to="/kontakt"
                                    data-testid="hero-cta-contact"
                                    className="inline-flex items-center gap-2 px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold text-ink border border-ink/30 hover:border-ink hover:bg-ink hover:text-paper transition-colors"
                                >
                                    Kontakt
                                    <ArrowUpRight size={14} />
                                </Link>
                            </div>

                            <div className="mt-10 flex items-center gap-6 text-sm text-inkSoft" data-testid="hero-rating">
                                <div className="flex items-center gap-1 text-brand">
                                    {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" strokeWidth={0} />)}
                                </div>
                                <span className="font-body font-medium">4,8 / 5</span>
                                <span className="text-ink/30">·</span>
                                <span className="font-body">109 Google Rezensionen</span>
                            </div>
                        </div>

                        {/* Image column */}
                        <div className="lg:col-span-5 relative reveal reveal-delay-2">
                            <div className="relative aspect-[4/5] overflow-hidden rounded-sm">
                                <img src={HERO_IMG} alt="Schuster bei der Arbeit" className="w-full h-full object-cover" data-testid="hero-image" />
                                <div className="absolute inset-0 ring-1 ring-ink/10" />
                            </div>
                            <div className="absolute -bottom-6 -left-6 hidden md:block bg-paper border-2 border-brand px-6 py-5 max-w-[240px]">
                                <p className="font-body text-sm font-bold text-ink uppercase tracking-wide mb-2">Öffnungszeiten</p>
                                <p className="font-body text-sm text-ink font-bold">Mo – Sa</p>
                                <p className="font-body text-sm text-ink font-bold">10:00 – 20:00</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Trust bar */}
                <div className="border-t border-line bg-white">
                    <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-6 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
                        <TrustItem icon={Zap} label="Sofort Service" />
                        <TrustItem icon={Award} label="Seit 2002" />
                        <TrustItem icon={ShieldCheck} label="Faire Preise" />
                        <TrustItem icon={MapPin} label="In Regensburg – DEZ" />
                    </div>
                </div>
            </section>

            {/* ---------- TESTIMONIALS ---------- */}
            <section className="py-24 md:py-28 overflow-hidden bg-white border-y border-line" data-testid="testimonials-section">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mb-14 text-center">
                    <h2 className="font-display text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1] font-medium text-brand">
                        Stimmen unserer Kunden
                    </h2>
                    <p className="mt-4 font-body text-sm tracking-[0.2em] uppercase text-inkSoft">
                        4,8 / 5 · 109 Google Bewertungen · Stand Okt. 2026
                    </p>
                    <a
                        href="https://g.page/r/CbT2bJrhqcEJEAE/review"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="google-review-link"
                        className="mt-6 inline-flex items-center gap-2 bg-brand text-paper px-6 py-3 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-brandDark transition-colors"
                    >
                        Bewerten Sie uns
                        <Star size={14} fill="#FACC15" strokeWidth={0} className="text-yellow-400" />
                    </a>
                </div>
                <div className="relative group">
                    <div className="flex gap-6 w-max animate-marquee group-hover:[animation-play-state:paused]" data-testid="testimonials-marquee">
                        {[...testimonials, ...testimonials].map((t, i) => (
                            <figure key={i} className="w-[380px] shrink-0 bg-paper border border-ink/10 p-8 flex flex-col" data-testid={`testimonial-card-${i}`}>
                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex items-center gap-1 text-brand">
                                        {[...Array(t.rating)].map((_, j) => <Star key={j} size={14} fill="currentColor" strokeWidth={0} />)}
                                    </div>
                                    {t.date && (
                                        <span className="font-body text-[10px] tracking-[0.2em] uppercase text-inkSoft">{t.date}</span>
                                    )}
                                </div>
                                <blockquote className="font-display text-lg italic text-ink leading-snug mb-6 flex-1">„{t.text}"</blockquote>
                                <figcaption className="font-body text-xs tracking-[0.2em] uppercase text-inkSoft">— {t.name}</figcaption>
                            </figure>
                        ))}
                    </div>
                </div>
            </section>

            {/* ---------- LOCATION ---------- */}
            <section className="py-24 md:py-28 bg-ink text-paper" data-testid="location-section">
                <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
                    <div className="lg:col-span-6 order-2 lg:order-1">
                        <div className="aspect-[4/3] overflow-hidden rounded-sm border border-paper/10">
                            <iframe
                                title="Standort"
                                src="https://www.google.com/maps?q=Weichser+Weg+5,+93059+Regensburg&output=embed"
                                width="100%" height="100%" style={{ border: 0, filter: "grayscale(0.5) contrast(1.1)" }}
                                loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>
                    </div>
                    <div className="lg:col-span-6 order-1 lg:order-2">
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1] mb-8">
                            Donau-Einkaufszentrum,<br/>Ebene 2.
                        </h2>
                        <div className="space-y-5 font-body text-sm font-light text-paper/80">
                            <div className="flex gap-4 items-start"><MapPin size={18} className="mt-0.5 text-brand shrink-0" /><span>Weichser Weg 5, 93059 Regensburg<br/>Donau-Einkaufszentrum (DEZ)</span></div>
                            <div className="flex gap-4 items-start"><Clock size={18} className="mt-0.5 text-brand shrink-0" /><span>Mo – Sa: 10:00 – 20:00 Uhr</span></div>
                            <div className="flex gap-4 items-start"><Phone size={18} className="mt-0.5 text-brand shrink-0" /><a href="tel:+499414610027" className="hover:text-brand transition-colors">+49 941 4610027</a></div>
                        </div>
                        <div className="mt-10 flex flex-wrap gap-4">
                            <a href="https://www.google.com/maps/search/?api=1&query=Weichser+Weg+5+93059+Regensburg" target="_blank" rel="noopener noreferrer" data-testid="location-maps-link" className="inline-flex items-center gap-2 bg-brand text-paper px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-brandDark transition-colors">
                                Route planen <ArrowUpRight size={14} />
                            </a>
                            <Link to="/kontakt" className="inline-flex items-center gap-2 px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold text-paper border border-paper/30 hover:border-paper transition-colors">
                                Kontaktieren
                            </Link>
                            <a href="https://wa.me/4917620366268" target="_blank" rel="noopener noreferrer" data-testid="location-whatsapp-link" className="inline-flex items-center gap-2 bg-[#25D366] text-white px-7 py-4 text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#1DA851] transition-colors">
                                <MessageCircle size={14} /> WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

function TrustItem({ icon: Icon, label, sub }) {
    return (
        <div className="flex items-center gap-3">
            <Icon size={22} className="text-brand shrink-0" strokeWidth={1.5} />
            <div>
                <p className="font-body text-sm font-semibold text-ink leading-none">{label}</p>
                {sub && <p className="font-body text-xs text-inkSoft mt-1">{sub}</p>}
            </div>
        </div>
    );
}

function ServiceTile({ img, title, sub, to, dark }) {
    return (
        <Link to={to} className={`group block overflow-hidden border ${dark ? "bg-ink text-paper border-ink" : "bg-white text-ink border-line"}`}>
            <div className="aspect-[4/3] overflow-hidden">
                <img src={img} alt={title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            </div>
            <div className="p-6 flex items-start justify-between gap-3">
                <div>
                    <h3 className="font-display text-2xl tracking-tight">{title}</h3>
                    <p className={`font-body text-xs tracking-[0.15em] uppercase mt-1 ${dark ? "text-paper/60" : "text-inkSoft"}`}>{sub}</p>
                </div>
                <ArrowUpRight size={20} className={`${dark ? "text-brand" : "text-brand"} group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform`} />
            </div>
        </Link>
    );
}
